import React from 'react';
import NumberFormat from 'react-number-format';

export const DVDD = (props) => {

    const ShowEdit = () => {
        props.showEditThongTin();
    }

    return (
        <div className="thong-tin">
            {
                props.thongTin.tenxa ? <table className="table table-bordered" width="100%">
                    <thead>
                        <tr>
                            <th colSpan="2"> Bản đồ chất lượng đất
                            {
                                    props.admin ? <button type="button" className="btn btn-primary btn-sm suathongtin" onClick={ShowEdit}><i className='fas fa-edit'></i></button> : ''
                                }
                            </th>
                        </tr>
                        <tr>
                            <th className="col-name">Tên</th>
                            <th>Thông tin</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td className="col-name">Huyện</td>
                            <td>Chư Pưh</td>
                        </tr>
                        <tr>
                            <td className="col-name">Xã</td>
                            <td>{props.thongTin?.tenxa}</td>
                        </tr>
                        <tr>
                        <td className="col-name">Diện tích(ha)</td>
                            <td>
                                <NumberFormat value={props.thongTin?.dt_ha} displayType={'text'} thousandSeparator={true} decimalScale={2}></NumberFormat>
                            </td>
                        </tr>
                        <tr>
                            <td className="col-name">Mã dvdd</td>
                            <td>{props.thongTin?.dvdd_h}</td>
                        </tr>
                        <tr>
                            <td className="col-name">Chế độ tưới</td>
                            <td>{props.thongTin?.phancaptuoi}</td>
                        </tr>
                        {/* <tr>
                            <td className="col-name">Chế độ tiêu</td>
                            <td>{props.thongTin?.tieu}</td>
                        </tr> */}
                        {/* <tr>
                            <td className="col-name">Địa hình tương đối</td>
                            <td>{props.thongTin?.diaHinh}</td>
                        </tr> */}
                        <tr>
                            <td className="col-name">Độ dốc</td>
                            <td>{props.thongTin?.phancapdoc}</td>
                        </tr>
                        <tr>
                            <td className="col-name">Mức độ đá lẫn</td>
                            <td>{props.thongTin?.phancapdalan}</td>
                        </tr>
                        <tr>
                            <td className="col-name">Độ day tầng đất</td>
                            <td>{props.thongTin?.phancapdoday}</td>
                        </tr>
                        <tr>
                            <td className="col-name">Thành phần cơ giới</td>
                            <td>{props.thongTin?.phancaptpcg}</td>
                        </tr>
                        <tr>
                            <td className="col-name">Độ phì</td>
                            <td>{props.thongTin?.phancapfe}</td>
                        </tr>
                    </tbody>
                </table> : <h5 className="text-center">Không có thông tin</h5>
            }
        </div>
    )
};